'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const EmptyStateFooter = renderWithRef('EmptyStateFooter', null, (e, r)=>jsx(RenderComp, {
        root: "div",
        forwardedRef: r,
        classNames: [
            'swan-empty-state-footer'
        ],
        props: e,
        children: e.children
    }));

export { EmptyStateFooter };
